import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import i18n from '@/i18n/config';

export type SupportedLanguage = 'en' | 'ar';
export type Direction = 'ltr' | 'rtl';

interface LanguageState {
  language: SupportedLanguage;
  direction: Direction;
  setLanguage: (lang: SupportedLanguage) => void;
}

const LANG_DIR_MAP: Record<SupportedLanguage, Direction> = {
  en: 'ltr',
  ar: 'rtl',
};

function applyToDocument(lang: SupportedLanguage, dir: Direction) {
  document.documentElement.lang = lang;
  document.documentElement.dir = dir;
}

export const useLanguageStore = create<LanguageState>()(
  devtools(
    persist(
      (set) => ({
        language: 'en',
        direction: 'ltr',

        setLanguage: (lang) => {
          const dir = LANG_DIR_MAP[lang];
          i18n.changeLanguage(lang);
          applyToDocument(lang, dir);
          set({ language: lang, direction: dir });
        },
      }),
      {
        name: 'language-preference',
        onRehydrateStorage: () => {
          return (state: LanguageState | undefined) => {
            if (state) {
              applyToDocument(state.language, state.direction);
              i18n.changeLanguage(state.language);
            }
          };
        },
      }
    ),
    { name: 'language-store' }
  )
);
